import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::show
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:162
* @route '/license-scans/{licenseScan}/images/{side}'
*/
export const show = (args: { licenseScan: string | { id: string }, side: string | number } | [licenseScan: string | { id: string }, side: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/license-scans/{licenseScan}/images/{side}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::show
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:162
* @route '/license-scans/{licenseScan}/images/{side}'
*/
show.url = (args: { licenseScan: string | { id: string }, side: string | number } | [licenseScan: string | { id: string }, side: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            licenseScan: args[0],
            side: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        licenseScan: typeof args.licenseScan === 'object'
        ? args.licenseScan.id
        : args.licenseScan,
        side: args.side,
    }

    return show.definition.url
            .replace('{licenseScan}', parsedArgs.licenseScan.toString())
            .replace('{side}', parsedArgs.side.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::show
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:162
* @route '/license-scans/{licenseScan}/images/{side}'
*/
show.get = (args: { licenseScan: string | { id: string }, side: string | number } | [licenseScan: string | { id: string }, side: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::show
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:162
* @route '/license-scans/{licenseScan}/images/{side}'
*/
show.head = (args: { licenseScan: string | { id: string }, side: string | number } | [licenseScan: string | { id: string }, side: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::show
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:162
* @route '/license-scans/{licenseScan}/images/{side}'
*/
const showForm = (args: { licenseScan: string | { id: string }, side: string | number } | [licenseScan: string | { id: string }, side: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::show
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:162
* @route '/license-scans/{licenseScan}/images/{side}'
*/
showForm.get = (args: { licenseScan: string | { id: string }, side: string | number } | [licenseScan: string | { id: string }, side: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\LicenseScanController::show
* @see app/Http/Controllers/Admin/Bookings/LicenseScanController.php:162
* @route '/license-scans/{licenseScan}/images/{side}'
*/
showForm.head = (args: { licenseScan: string | { id: string }, side: string | number } | [licenseScan: string | { id: string }, side: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const images = {
    show: Object.assign(show, show),
}

export default images